import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isAuthenticated: false,
};

export const AuthSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        login: (state) => {
            state.isAuthenticated = true;
        },
        logout: (state) => {
            state.isAuthenticated = false;
        },
    },
});

export const { login, logout } = AuthSlice.actions;

export default AuthSlice.reducer;
